export class AppointmentFulfilledListPresenter extends Array {
  constructor(result) {
    const {
      appointment_list: fulfilledMonths
    } = result;

    const mapped = fulfilledMonths.map(month => ({
      fulfilledAtThaiDateText: month.fulfilled_at_thai_date,
      fulfilledYearMonth: month.fulfilled_year_month,
      homes: month.homes.map(home => ({
        id: home.home_id,
        addressNo: home.address_no,
        appointments: home.appointments.map(appointment => ({
          id: appointment.appointment_id,
          serviceName: appointment.service_name,
        }))
      }))
    }));

    super(...mapped);
  }
}
